import { TelemetryType } from '../../api/apiservice'
import BaseSensor from './BaseSensor'

export default class LinePsi extends BaseSensor {
  constructor(props) {
    super(props, TelemetryType.Vibration, 'Vibration')
  }

  protected getDisplayReading(readingValue?: number): number | undefined {
    return readingValue
  }
}
